/* eslint-disable import/prefer-default-export, no-shadow */
export const AusStateList = [
  { value: '', display: 'Select' },
  { value: 'VIC', display: 'VIC' },
  { value: 'NSW', display: 'NSW' },
  { value: 'ACT', display: 'ACT' },
  { value: 'QLD', display: 'QLD' },
  { value: 'WA', display: 'WA' },
  { value: 'NT', display: 'NT' },
  { value: 'SA', display: 'SA' },
  { value: 'TAS', display: 'TAS' },
];

export const TitleOptionsList = [
  { value: 'MISS', display: 'Miss' },
  { value: 'MR', display: 'Mr' },
  { value: 'MRS', display: 'Mrs' },
  { value: 'MS', display: 'Ms' },
  { value: 'OTHER', display: 'Other' },
];

export const WhoPreparedReport = [
  { value: 'Case worker (e.g. special FV case worker)', display: 'Case worker (e.g. special FV case worker)' },
  { value: 'Social worker (e.g. special FV case worker)', display: 'Social worker (e.g. special FV case worker)' },
  { value: 'Financial counsellor', display: 'Financial counsellor' },
  { value: 'Health practitioner', display: 'Health practitioner' },
  { value: 'School principal', display: 'School principal' },
  { value: 'School welfare coordinator', display: 'School welfare coordinator' },
  { value: 'Police', display: 'Police' },
  { value: 'A court', display: 'A court' },
  { value: 'Other', display: 'Other' },
];

export const GenderOptionsList = [
  { value: 'male', display: 'Male' },
  { value: 'female', display: 'Female' },
  { value: 'self-described', display: 'Self-described' },
];

export const OriginOptionsList = [
  { value: 'aboriginal', display: 'Aboriginal' },
  { value: 'torres-strait-islander', display: 'Torres Strait Islander' },
  { value: 'aboriginal-and-torres-strait-islander', display: 'Aboriginal and Torres Strait Islander' },
  { value: 'neither-aboriginal-and-torres-strait-islander', display: 'Neither Aboriginal nor Torres Strait Islander' },
];

export const EnglishProficiencyOptionsList = [
  { value: 'not-at-all', display: 'Not at all' },
  { value: 'poorly', display: 'Poorly' },
  { value: 'adequately', display: 'Adequately' },
  { value: 'very-well', display: 'Very well' },
];
